import { LoginWidget } from '../components';
import { connect } from 'react-redux';

function select(state) {
    return {
        currentRoute: state.appState.currentRoute,
        account: state.registerAccount,
        user: state.activeUser
    }
}

export default connect(select)(LoginWidget);



// WEBPACK FOOTER //
// ./web-app/containers/login.jsx